var _this = this;
import * as tslib_1 from "tslib";
import { orchestrator } from 'satcheljs';
import { onFolderClickedInMoveToControlAction } from 'owa-mail-moveto-control';
import { resetFocus } from '../mailModuleAutoFocusManager';
export default orchestrator(onFolderClickedInMoveToControlAction, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        resetFocus();
        return [2 /*return*/];
    });
}); });
//# sourceMappingURL=resetFocus.js.map